export default __webpack_public_path__ + "components/page-header/static/mountain-forecast-outside__logo--clear-8d9ebd0a07772029ba05bac6ed2f4733.png";